const libs = ["places", "maps", "marker"] as const;
export default libs;
